import {Component, OnDestroy, OnInit} from '@angular/core';
import {GridApi, GridOptions, IDatasource, IGetRowsParams} from 'ag-grid-community';
import {HhgRateDownloadService} from './hhg-rate-download.service';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UserService} from '../../services/user/user.service';
import {User} from '../../services/user/user';
import {ISubscription} from 'rxjs-compat/Subscription';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {api_error, hhg_download_success} from '../../shared/common-components/AppConstants';
import * as FileSaver from 'file-saver';
import {DownloadFileResponse} from '../../shared/common-components/file-storage/downloadFileResponse';
import {Ratesprocuredownload} from '../frt-rates-download/ratesprocuredownload';
import { BehaviorSubject } from 'rxjs';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'app-hhg-rates-download',
    templateUrl: './hhg-rates-download.component.html',
    styleUrls: ['./hhg-rates-download.component.css'],
    standalone: false
})
/**
 * using ag-grid for this for reference please check
 * @link https://www.ag-grid.com/best-angular-2-data-grid/
 */
export class HhgRatesDownloadComponent implements OnInit, OnDestroy {
  private tmssloader;
  currentUser: User | any;
  carrierId: any;
  public modalRef: BsModalRef;
  private gridApi!: GridApi<any>;
  public columnDefs;
  public components;
  public defaultColDef;
  public rowSelection;
  public rowModelType;
  public paginationPageSize;
  public cacheOverflowSize;
  public maxConcurrentDatasourceRequests;
  public infiniteInitialRowCount;
  public maxBlocksInCache;
  public getRowNodeId;
  public cacheBlockSize;
  paramsObj: any;
  public overlayLoadingTemplate;
  public overlayNoRowsTemplate;
  showExport = false;
  public domLayout;
  private observer$ = new BehaviorSubject(true);
  rateBidCyclesId: any;

  constructor(private hhgrateDownload: HhgRateDownloadService, private hhgService: HhgCarrierRateFilingService,
              private alertService: AlertService, private loader: LoadingService, private userService: UserService,
              private modalService: BsModalService, private carrierService: CarrierService ) {
    this.tmssloader = this.loader;
    this.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';
    this.overlayNoRowsTemplate = '<span style="margin: 27px 53px 0 0;">No results found. Please adjust your filters.</span>';

    /**
     * @description getting current user from the behavioural subject
     */
    this.tmssloader.show();
    this.hhgService.getCarrierIdByUser().subscribe(carrierId => {
      this.carrierId = carrierId;
      this.tmssloader.hide();
    }, (error) => {
      this.tmssloader.hide();
      this.alertService.error('Unable to load TSP info values. Please try again later or contact system administrator');
    });


    /**
     * adding column definitions where we can add more remove more based on the field the grid will map to json object
     */
    this.columnDefs = [
      {
        headerName: 'UPDATE FLAG',
        field: 'updateFlag',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'RATE TYPE',
        field: 'rateType',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TENDER ID',
        field: 'tenderId',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'SRO ID',
        field: 'sroId',
        filter: 'agTextColumnFilter'
      },

      {
        headerName: 'ORIGIN',
        field: 'origin',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'DESTINATION',
        field: 'destination',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'LINEHAUL%',
        field: 'linehaul'
      },
      {
        headerName: 'CATEGORY 1 VEHICLE',
        field: 'classVehicle1'
      },
      {
        headerName: 'CATEGORY 2 VEHICLE',
        field: 'classVehicle2'
      },
      {
        headerName: 'CATEGORY 3 VEHICLE',
        field: 'classVehicle3'
      },
      {
        headerName: 'STORAGEIN TRANSIT',
        field: 'storageInTransit'
      },
      {
        headerName: 'ACCESSORIALS',
        field: 'accessorials'
      },
      {
        headerName: 'UNACCOMPANIED AIRBAG',
        field: 'unaccompaniedAirBag'
      },
      {
        headerName: 'BOOKING EMAIL',
        field: 'bookingEmail',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'BOOKING PHONE',
        field: 'bookingPhone'
      }
    ];
    this.components = {
      loadingRenderer: function (params) {
        if (params.value !== undefined) {
          return params.value;
        } else {
          return '<img src="../images/loading.gif">';
        }
      }
    };
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      autoHeight: true,
      suppressDragLeaveHidesColumns: true,
      filterParams: {
        suppressAndOrCondition: true
      }
    };
    this.rowSelection = 'multiple';
    this.rowModelType = 'infinite';
    this.cacheOverflowSize = 2;
    this.maxConcurrentDatasourceRequests = 2;
    this.infiniteInitialRowCount = 1;
    this.maxBlocksInCache = 2;
    this.paginationPageSize = 200;
    this.cacheBlockSize = 200;
    this.getRowNodeId = function (item) {
      return item.id;
    };

    this.domLayout = 'autoHeight';
    this.carrierService.getRateBidCycleId()
    .pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
    this.rateBidCyclesId = res?.ratesBidcyclesId;
    });

  }

  /**
   * The gridOptions is a 'one stop shop' for the entire interface into the grid. The grid options can be used regardless of the framework you are using, however if you are using a framework,
   * you can additionally achieve what grid options provides with your frameworks bindings. How to configure for the particular framework is explained further down this page.
   * we are using infinite row model which will call server to get data every time page changes
   */
  gridOptions: GridOptions = {
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSize: 500,
    cacheBlockSize: 500,
    headerHeight: 50
  };


  /**
   *  Setting new datasource into the grid. The grid will reset all paging and load the first page. If you want to reset the paging but keep the datasource, call this method with the same datasource.
   */
  dataSource: IDatasource = {
    getRows: (params: IGetRowsParams) => {
      const paramsObj = HhgRatesDownloadComponent.getFilterModal(params.filterModel, params.sortModel);
      this.paramsObj = paramsObj;
      if (this.carrierId !== null && this.carrierId !== undefined) {
        this.gridApi.showLoadingOverlay();
        const ratesPoc = this.buildData();
        this.hhgrateDownload.getRowDataWithPage(ratesPoc, this.gridApi.paginationGetCurrentPage(), this.gridOptions.paginationPageSize).subscribe((data: any) => {
          const endParam = this.gridOptions.cacheBlockSize;
          setTimeout(function () {
            const dataAfterSortingAndFiltering = sortAndFilter(data.content, params.sortModel, params.filterModel);
            const rowsThisPage = dataAfterSortingAndFiltering.slice(0, endParam);
            params.successCallback(
                rowsThisPage,
                data.totalElements
            );
          }, 500);
          this.gridApi.hideOverlay();
          this.showExport = true;
          if (data.content.length === 0) {
            this.gridApi.showNoRowsOverlay();
            this.showExport = false;
          } else {
            this.showExport = true;
            this.gridApi.hideOverlay();
          }
        }, error => {
          this.alertService.info('No results found. Please adjust your filters.');
          this.gridApi.hideOverlay();
          this.showExport = false;
        });
      }
    }
  };

  /**
   * getting the filter and sort params
   * @param: filterParam
   * @param: sortParam
   */
  static getFilterModal(filterParam, sortParam) {
    const paramsObj = [];
    if (filterParam !== null && filterParam !== undefined) {
      if (filterParam.updateFlag) {
        paramsObj.push({name : 'updateFlag' , value: filterParam.updateFlag.filter});
      } else {
        paramsObj.push({name : 'updateFlag' , value: ''});
      }
      if (filterParam.rateType) {
        paramsObj.push({name : 'rateType' , value: filterParam.rateType.filter});
      } else {
        paramsObj.push({name : 'rateType' , value: ''});
      }
      if (filterParam.sroMasterId) {
        paramsObj.push({name : 'sroMasterId' , value: filterParam.sroMasterId.filter});
      } else {
        paramsObj.push({name : 'sroMasterId' , value: ''});
      }
      if (filterParam.tenderId) {
        paramsObj.push({name : 'tenderId' , value: filterParam.tenderId.filter});
      } else {
        paramsObj.push({name : 'tenderId' , value: ''});
      }
      if (filterParam.sroId) {
        paramsObj.push({name : 'sroId' , value: filterParam.sroId.filter});
      } else {
        paramsObj.push({name : 'sroId' , value: ''});
      }
      if (filterParam.origin) {
        paramsObj.push({name : 'origin' , value: filterParam.origin.filter});
      } else {
        paramsObj.push({name : 'origin' , value: ''});
      }
      if (filterParam.destination) {
        paramsObj.push({name : 'destination' , value: filterParam.destination.filter});
      } else {
        paramsObj.push({name : 'destination' , value: ''});
      }
      if (filterParam.bookingEmail) {
        paramsObj.push({name : 'bookingEmail' , value: filterParam.bookingEmail.filter});
      } else {
        paramsObj.push({name : 'bookingEmail' , value: ''});
      }
    }

    if (sortParam !== null && sortParam !== undefined && sortParam.length > 0) {
      if (sortParam[0].colId && sortParam[0].sort) {
        paramsObj.push({name : 'orderByClause' , value: sortParam[0].colId + '_' + sortParam[0].sort});
      } else {
        paramsObj.push({name : 'orderByClause' , value: 'none'});
      }
    } else {
      paramsObj.push({name : 'orderByClause' , value: 'none'});
    }

    if (paramsObj.length === 0) {
      paramsObj.push({name : 'updateFlag' , value: ''});
      paramsObj.push({name : 'rateType' , value: ''});
      paramsObj.push({name : 'sroMasterId' , value: ''});
      paramsObj.push({name : 'orderByClause' , value: 'none'});
      paramsObj.push({name : 'tenderId' , value: ''});
      paramsObj.push({name : 'origin' , value: ''});
      paramsObj.push({name : 'destination' , value: ''});
      paramsObj.push({name : 'sroId' , value: ''});
      paramsObj.push({name : 'bookingEmail' , value: ''});
    }
    return paramsObj;
  }


  ngOnInit(): void {
  }

  /**
   * initializing the ag-grid
   * @param: params
   */
  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    params.api.resetRowHeights();
    this.gridApi = params.api;
    this.gridApi.setGridOption('datasource', this.dataSource);
  }

  /**
   * Exporting the data in the csv format
   */
  onBtExport() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Select Yes to download ONLY the information that is displayed on this page. Select No to download ALL of the information that is available from the HHG View Rates';
    this.modalRef.content.title = 'HHG View Rates';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No - download all rates with filters';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        const date = new Date();
        const params = {
          fileName: 'hhg-rates-report-' + date + '.csv',
          allColumns: true,
          columnSeparator: ','
        };
        this.gridApi.exportDataAsCsv(params);
        this.showExport = false;
        setTimeout(() => {
          this.showExport = true;
        }, 5200);
      } else if (result.obj === false) {
        let hhgrRatesResult: DownloadFileResponse;
        this.tmssloader.show();
        const ratesPoc = this.buildData();
        this.hhgrateDownload.exportDataFromServer(ratesPoc).subscribe((data: any) => {
          hhgrRatesResult = data as DownloadFileResponse;
          this.alertService.success2 ('Your download request has been received. System will create the file and notify you via email once the file is ready');
          this.tmssloader.hide();
        }, error => {
          this.alertService.error(api_error);
          this.tmssloader.hide();
        });
      }
    });

  }

  buildData() {
    const ratesPoc = new Ratesprocuredownload();
    const rateId = this.paramsObj.find( x => x.name === 'rateType').value;
    const orderByClause = this.paramsObj.find( x => x.name === 'orderByClause').value;
    const sroId = this.paramsObj.find( x => x.name === 'sroId').value ;
    const origzonedesc = this.paramsObj.find( x => x.name === 'origin').value ;
    const destzonedesc = this.paramsObj.find( x => x.name === 'destination').value ;
    const tenderid = this.paramsObj.find( x => x.name === 'tenderId').value ;
    const bookingEmail = this.paramsObj.find( x => x.name === 'bookingEmail').value ;
    const updateFlag = this.paramsObj.find( x => x.name === 'updateFlag').value ;
    const sroMasterId = this.paramsObj.find( x => x.name === 'sroMasterId').value ;
    ratesPoc.carrierId = this.carrierId;
    // ratesPoc.carrierId = 2425;
    ratesPoc.rateTypeId = rateId;
    ratesPoc.orderByClause = orderByClause;
    ratesPoc.sroId = sroId;
    ratesPoc.origzonedesc = origzonedesc;
    ratesPoc.destzonedesc = destzonedesc;
    ratesPoc.bookingEmail = bookingEmail;
    ratesPoc.updateFlag = updateFlag;
    ratesPoc.sroMasterId = sroMasterId;
    ratesPoc.tenderid = tenderid;
    ratesPoc.ratesBidcyclesId = this.rateBidCyclesId;
    return ratesPoc;
  }

  /**
   * destroying the subscription
   */
  ngOnDestroy(): void {
    this.observer$.next(false);
  }

}

/**
 * @param: allOfTheData
 * @param: sortModel
 * @param: filterModel
 */
function sortAndFilter(allOfTheData, sortModel, filterModel) {
  return sortData(sortModel, filterData(filterModel, allOfTheData));
}

/**
 * sorting the data
 * @param: sortModel
 * @param: data
 */
function sortData(sortModel, data) {
  const sortPresent = sortModel && sortModel.length > 0;
  if (!sortPresent) {
    return data;
  }
  const resultOfSort = data.slice();
  resultOfSort.sort(function(a, b) {
    for (let k = 0; k < sortModel.length; k++) {
      const sortColModel = sortModel[k];
      const valueA = a[sortColModel.colId];
      const valueB = b[sortColModel.colId];
      if (valueA === valueB) {
        continue;
      }
      const sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
      if (valueA > valueB) {
        return sortDirection;
      } else {
        return sortDirection * -1;
      }
    }
    return 0;
  });
  return resultOfSort;
}

/**
 * filtering the data
 * @param: filterModel
 * @param: data
 */
function filterData(filterModel, data) {
  const filterPresent = filterModel && Object.keys(filterModel).length > 0;
  if (!filterPresent) {
    return data;
  }
  const resultOfFilter = [];
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    if (filterModel.unaccompaniedAirBag) {
      if (filterModel.unaccompaniedAirBag.filter.toUpperCase().indexOf(item.unaccompaniedAirBag.toString().toUpperCase()) < 0) {
        continue;
      }
    }
    resultOfFilter.push(item);
  }
  return resultOfFilter;
}
